module.exports = __webpack_public_path__ + "static/media/2.9856b5f2.jpg";